/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ComputeSpeciesRequest
 */
export interface ComputeSpeciesRequest {
    /**
     * 
     */
    captureIds?: Array<string> | null;
    /**
     * 
     */
    allKeeps?: boolean;
}

/**
 * Check if a given object implements the ComputeSpeciesRequest interface.
 */
export function instanceOfComputeSpeciesRequest(value: object): value is ComputeSpeciesRequest {
    return true;
}

export function ComputeSpeciesRequestFromJSON(json: any): ComputeSpeciesRequest {
    return ComputeSpeciesRequestFromJSONTyped(json, false);
}

export function ComputeSpeciesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ComputeSpeciesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'captureIds': json['capture_ids'] === undefined ? undefined : json['capture_ids'] === null ? null : json['capture_ids'],
        'allKeeps': json['all_keeps'] == null ? undefined : json['all_keeps'],
    };
}

export function ComputeSpeciesRequestToJSON(json: any): ComputeSpeciesRequest {
    return ComputeSpeciesRequestToJSONTyped(json, false);
}

export function ComputeSpeciesRequestToJSONTyped(value?: ComputeSpeciesRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'capture_ids': value['captureIds'],
        'all_keeps': value['allKeeps'],
    };
}

